module.exports = __webpack_public_path__ + "img/GJSFX.d757813b.png";